import { Card, Divider, Flex, Typography, Switch, Button, Tooltip, theme, Checkbox } from 'antd'
import { CloseCircleOutlined, QuestionCircleOutlined, UpSquareOutlined, PlusCircleOutlined } from '@ant-design/icons'
const { Text } = Typography

export const AdvertisingSlots = () => {
    const {
        token: { colorPrimary }
    } = theme.useToken()
    return (
        <div>
            <Card style={{ backgroundColor: '#ffff', maxWidth: 350 }} bodyStyle={{ padding: '14px 0px' }}>
                <Flex justify={'space-between'} style={{ marginLeft: 14, marginRight: 14 }}>
                    <Text style={{ color: colorPrimary }}>
                        <strong>Отображать на бирже каналов</strong>
                    </Text>
                    <Tooltip title="Этот переключатель включает/выключает видимость вашего канала на бирже">
                        <QuestionCircleOutlined style={{ color: colorPrimary, cursor: 'help' }} />
                    </Tooltip>
                    <Switch />
                </Flex>
                <Divider style={{ margin: '10px 0' }} />
                <Flex
                    gap={'small'}
                    align={'center'}
                    justify={'space-between'}
                    style={{ marginLeft: 14, marginRight: 14 }}
                >
                    <Text style={{ color: colorPrimary, width: 250 }}>
                        Ваша ссылка не/активна и слоты не\доступны для бронирования
                    </Text>
                    <Button type="primary" icon={<UpSquareOutlined />} />
                </Flex>
            </Card>

            <Card
                style={{ backgroundColor: '#ffff', maxWidth: 350, marginTop: 40 }}
                bodyStyle={{ padding: '14px 0px' }}
            >
                <Flex justify={'center'}>
                    <Text style={{ color: colorPrimary, fontSize: 16, textAlign: 'center' }}>
                        <strong>Расписание для биржи каналов</strong>
                    </Text>
                </Flex>
                <Divider style={{ margin: '10px 0' }} />
                <Flex align={'center'} justify={'space-between'} style={{ marginLeft: 14, marginRight: 14 }}>
                    <Checkbox>Пн</Checkbox>
                    <Button type={'primary'} style={{ width: 188 }} size={'large'}>
                        Слот свободен
                    </Button>
                    <Button
                        color="default"
                        shape="circle"
                        icon={<PlusCircleOutlined style={{ color: colorPrimary }} />}
                    />
                </Flex>
                <Divider style={{ margin: '10px 0' }} />
                {[1, 2, 3, 4, 5, 6].map((item, i) => (
                    <>
                        <Flex align={'center'} justify={'space-between'} style={{ marginLeft: 14, marginRight: 14 }}>
                            <Checkbox>Пн</Checkbox>
                            <Button type={'primary'} style={{ width: 188 }} size={'large'}>
                                Слот свободен
                            </Button>
                            <Button
                                color="default"
                                shape="circle"
                                icon={<CloseCircleOutlined style={{ color: colorPrimary }} />}
                            />
                        </Flex>
                        <Divider style={{ margin: '10px 0' }} />
                    </>
                ))}
            </Card>
        </div>
    )
}
